import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd';
import find from 'lodash/find';
import get from 'lodash/get';
import FilterWrapper from '../../FilterWrapper';
import ProjectTypePopover from './ProjectTypePopover';
import { setOpenSearchFilter } from '../../../../actions';
import { t } from '../../../../helpers/t';

const FILTER_NAME = 'projectType';

function DailyPriceFilter() {
  const {
    openSearchFilter,
    parameters: {
      parent_project_type_ids_contains_element: parentProjectTypeId,
    },
  } = useSelector((state) => state.searchFilters);
  const { searchFilterProjectTypes } = useSelector((state) => state.env);
  const dispatch = useDispatch();

  const toggleFilterVisible = () => (
    openSearchFilter === FILTER_NAME
      ? dispatch(setOpenSearchFilter(null))
      : dispatch(setOpenSearchFilter(FILTER_NAME))
  );

  const determineProjectTypeName = (projectTypeId) => {
    const parentProjectTypes = searchFilterProjectTypes || {};
    const parentProject = find(parentProjectTypes, { id: projectTypeId });

    return parentProject
      ? get(parentProject, 'name', t('directives.listings.listingFilters.projectType'))
      : t('directives.listings.listingFilters.projectType');
  };

  let parentProjectTypeName = determineProjectTypeName(parentProjectTypeId);

  useEffect(() => {
    parentProjectTypeName = determineProjectTypeName(parentProjectTypeId);
  }, [determineProjectTypeName, parentProjectTypeId]);

  return (
    <FilterWrapper>
      <ProjectTypePopover>
        <Button type={parentProjectTypeId ? 'primary' : 'default'} onClick={() => toggleFilterVisible()}>
          {parentProjectTypeName}
        </Button>
      </ProjectTypePopover>
    </FilterWrapper>
  );
}

export default DailyPriceFilter;
